export { createDeflateEncoder } from './deflateEncoder';
export { startDeflateWorker, getDeflateWorkerStatus, resetDeflateWorkerState, } from './deflateWorker';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/domain/deflate/index.js
// module id = 1253
// module chunks = 0